import { SET_TOOLBAR } from "../action-types";

export default {
  mounted() {
    const { toolbar } = this.$options;
    if (toolbar) {
      // Set vm context to toolbar.menu.action
      if (toolbar && toolbar.menu && toolbar.menu.length) {
        toolbar.menu = toolbar.menu.map(item => ({
          ...item,
          action: item.action ? item.action.bind(this) : undefined
        }));
      }

      // Set toolbar in store
      this.$store.commit(SET_TOOLBAR, toolbar);
    }
  }
};
